<span *ngIf="companyLocation">
  <h2>Netzbetreiber / Messstellenbetreiber</h2>
  <b>{{ companyLocation.external_id }} / {{ companyLocation.name }}</b>
  <br />
  <span *ngIf="companyLocation.contactData">
    {{ companyLocation.contactData.street }}
    {{ companyLocation.contactData.streetNo }}
    <br />
    {{ companyLocation.contactData.zipCode }}
    {{ companyLocation.contactData.city }}
  </span>
</span>
